import { default as _91_46_46_46404_93g7mL91325GMeta } from "/home/runner/work/shoe-nuxt/shoe-nuxt/pages/[...404].vue?macro=true";
import { default as _91slug_93vJPU6f79aJMeta } from "/home/runner/work/shoe-nuxt/shoe-nuxt/pages/article/[slug].vue?macro=true";
import { default as _91slug_93p5Q9L4DDxJMeta } from "/home/runner/work/shoe-nuxt/shoe-nuxt/pages/blog/[slug].vue?macro=true";
import { default as cart7LYLl0ZQuRMeta } from "/home/runner/work/shoe-nuxt/shoe-nuxt/pages/cart.vue?macro=true";
import { default as checkoutUQrYNpH7tKMeta } from "/home/runner/work/shoe-nuxt/shoe-nuxt/pages/checkout.vue?macro=true";
import { default as _91id_93s8N8seOl7IMeta } from "/home/runner/work/shoe-nuxt/shoe-nuxt/pages/collections/[id].vue?macro=true";
import { default as indexKkJ0RCCXy0Meta } from "/home/runner/work/shoe-nuxt/shoe-nuxt/pages/index.vue?macro=true";
import { default as _91page_93Z8g5HLxpsvMeta } from "/home/runner/work/shoe-nuxt/shoe-nuxt/pages/pages/[page].vue?macro=true";
import { default as _91sku_93TVO5lNNpMwMeta } from "/home/runner/work/shoe-nuxt/shoe-nuxt/pages/products/[sku].vue?macro=true";
import { default as _91order_id_93FF1WdVZpuQMeta } from "/home/runner/work/shoe-nuxt/shoe-nuxt/pages/success/[order_id].vue?macro=true";
export default [
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/home/runner/work/shoe-nuxt/shoe-nuxt/pages/[...404].vue")
  },
  {
    name: "article-slug",
    path: "/article/:slug()",
    component: () => import("/home/runner/work/shoe-nuxt/shoe-nuxt/pages/article/[slug].vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/home/runner/work/shoe-nuxt/shoe-nuxt/pages/blog/[slug].vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/home/runner/work/shoe-nuxt/shoe-nuxt/pages/cart.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkoutUQrYNpH7tKMeta || {},
    component: () => import("/home/runner/work/shoe-nuxt/shoe-nuxt/pages/checkout.vue")
  },
  {
    name: "collections-id",
    path: "/collections/:id()",
    component: () => import("/home/runner/work/shoe-nuxt/shoe-nuxt/pages/collections/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/shoe-nuxt/shoe-nuxt/pages/index.vue")
  },
  {
    name: "pages-page",
    path: "/pages/:page()",
    component: () => import("/home/runner/work/shoe-nuxt/shoe-nuxt/pages/pages/[page].vue")
  },
  {
    name: "products-sku",
    path: "/products/:sku()",
    component: () => import("/home/runner/work/shoe-nuxt/shoe-nuxt/pages/products/[sku].vue")
  },
  {
    name: "success-order_id",
    path: "/success/:order_id()",
    meta: _91order_id_93FF1WdVZpuQMeta || {},
    component: () => import("/home/runner/work/shoe-nuxt/shoe-nuxt/pages/success/[order_id].vue")
  }
]